angular.module('rjmNg.api').factory("DashboardItem", [
  "$resource"
  "phpServiceUrl"
  ($resource, phpServiceUrl) ->

    decrementItem = (item) ->

      item.row-- if item.row?
      item.column-- if item.column?
      item

    incrementItem = (item) ->
      item.row++ if item.row?
      item.column++ if item.column?
      item

    # increment dashboard items to work with our back-end (1-based)
    preProcessDashboardItems = (data, headersGetter) ->
      items = null
      if angular.isArray(data)
        items = for dItem in data
          copy = angular.extend {}, dItem
          # deleting these properties since they are large and aren't used by the controller
          delete copy.chart
          delete copy.figure
          incrementItem copy
        return angular.toJson(items)
      else
        return data

    # decrement dashboard items to work with angular-gridster (0-based)
    postProcessDashboardItems = (data, headersGetter) ->

      # if data is an error message fromJson will fail so just return the data
      try
        items = if angular.isString(data) then angular.fromJson(data) else data
      catch error
        return data

      if angular.isArray(items)
        items = for dItem in items
          decrementItem dItem
      else
        items = decrementItem items

      return items

    # We need to intercept query/update/get/save methods in order to properly increment/decrement rows/columns for dashboard items
    DashboardItem = $resource(phpServiceUrl("/client/:clientId/dashboarditem/:id"), {},
        query:
          method: 'GET'
          isArray: true
          transformResponse: postProcessDashboardItems
        bulkUpdate:
          method: 'PUT'
          transformRequest: preProcessDashboardItems
        get:
          method: 'GET'
          transformResponse: postProcessDashboardItems
        save:
          method: 'POST'
          transformResponse: postProcessDashboardItems
    )
  ]
)
